

























































































import { sortBy } from 'lodash-es'
import Avatar from '@/components/Avatar.vue'
import 'pace-progressbar'
import 'pace-progressbar/themes/red/pace-theme-minimal.css'
import DropdownButton from '@/components/DropdownButton.vue'
import { Button, Icon } from '@alpha/ink'
import ClickOutside from 'v-click-outside'
import { Component, Vue, Prop } from 'vue-property-decorator'
import store from '@/store'
import AddTestModal from '@/components/AddTest/AddTestModal.vue'

@Component({
  components: {
    Avatar,
    DropdownButton,
    AddTestModal,
    Button,
    Icon
  },
  directives: {
    clickOutside: ClickOutside.directive
  }
})
export default class NavigationBar extends Vue {
  @Prop({ default: false }) readonly showAudiences!: boolean;
  showAddTestModal = false
  orgQueueLink: string | null = null

  get workspaceId (): string {
    return this.$route.params.workspaceId
  }

  get accountId () {
    return store.state.accountId
  }

  get isAdminOrOrgAdmin () {
    if (store.state.user.authenticatedUser) {
      const orgAdminPriv = store.state.user.authenticatedUser.orgAdminAccess
      let orgAdmin = false
      if (orgAdminPriv && store.state.workspace.workspace.payload) {
        orgAdmin = orgAdminPriv.includes(store.state.workspace.workspace.payload.organization.id)
      }
      return store.state.user.authenticatedUser.admin || orgAdmin
    } else {
      return false
    }
  }

  get workspaces () {
    const workspaces = store.getters.user.allWorkspaces
    return sortBy(workspaces, w => w.name)
  }

  get workspacePayload () {
    return store.state.workspace.workspace.payload
  }

  get orgId () {
    if (this.workspacePayload) {
      return this.workspacePayload.organization.id
    } else {
      return this.workspaces[0].organizationId
    }
  }

  logout (): void {
    store.dispatch.user.logout()
  }
}
